module.exports = __webpack_public_path__ + "static/media/GaliciaWhiteInline.4d3dc991.svg";